import script from "./getSuccess.vue?vue&type=script&setup=true&lang=ts"
export * from "./getSuccess.vue?vue&type=script&setup=true&lang=ts"

import "./getSuccess.vue?vue&type=style&index=0&id=09f80614&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09f80614"]])

export default __exports__